import DealSelect from '@screens/configuration/deal/select'

export default function DealSelectPage() {
  return <DealSelect />
}
